import { createFileRoute } from '@tanstack/react-router';
import { AdminUsersPage } from '@/modules/admin-users/users-page';

/**
 * `?f=` is the encoded filter selection. The filters module writes it with
 * `history.replaceState`, but it still has to be declared here — otherwise a
 * router navigation would validate it away and drop the selection.
 *
 * The path matches `webreports.WEBObjects` (ObjectID 201, app portal-v2), which
 * is what puts the entry in the menu; it deliberately differs from the legacy
 * `/administration-users` so both pages can live on one origin.
 *
 * An index route, not `users-rights.tsx`: a file at that name would become the
 * *parent* of `users-rights.$userId`, and a parent without an `<Outlet/>`
 * swallows its children — the list would render at every `/users-rights/415`
 * and the user's page would never appear.
 */
interface UsersRightsSearch {
  f?: string;
}

export const Route = createFileRoute('/_auth/users-rights/')({
  validateSearch: (search: Record<string, unknown>): UsersRightsSearch => ({
    f: typeof search.f === 'string' ? search.f : undefined,
  }),
  component: AdminUsersPage,
});
